import React, { Component } from 'react';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import DispatchList from '../../components/DispatchList';

class PickupList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Shipper Pickup',
      },
      {
        breadcrumbName: 'List',
      },
    ];

    const dispatchListColumns = [
      {
        Header: 'Dispatch ID',
        accessor: 'dh_id',
      },
      {
        Header: 'Courier',
        accessor: 'driver',
      },
      {
        Header: 'Status',
        accessor: 'status',
        sortable: false,
      },
      {
        Header: 'Date',
        accessor: 'dispatch_date',
      },
    ];

    const customFilter = {
      id: 'type',
      value: 'pickup',
    };

    return (
      <div className="PickupList">
        <PageHeader title="Shipper Pickup" routes={breadCrumbs} />
        <Container>
          <DispatchList
            hasExport
            dispatchListColumns={dispatchListColumns}
            customFilter={customFilter}
            fetchText="Fetching Pickup List. . ."
            urlEndpoint="/pickup"
            typeDispatch="pickup"
          />
        </Container>
      </div>
    );
  }
}

export default PickupList;
